import React, { useState, useEffect } from 'react';
import {
  AdminContentContainer,
  AdminContentTitle,
  CancelDateForm,
  CancelDateLabel,
  CancelDateInput,
  SearchButton,
  BlockedList,
  NoBlocks,
  BlockedItem,
  RemoveButton,
} from '../styles';
import { adminGetBlockedDates, adminCreateBlockedDate, adminDeleteBlockedDate } from '../api';
import { Spinner } from '.';

const BlockDates = () => {
  const [selectedDate, setSelectedDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [reason, setReason] = useState('');
  const [blockedTimes, setBlockedTimes] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchBlockedDates = async () => {
      try {

        const response = await adminGetBlockedDates();

        if (!response.ok) throw new Error('Erro ao buscar bloqueios');

        const data = await response.json();
  
        // Garantindo que blockedDates é um array válido antes de setar
        setBlockedTimes(Array.isArray(data.blockedDates) ? data.blockedDates : []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlockedDates();
  }, []);

  const updateBlockedDates = async () => {
    try {
      setLoading(true);

      const response = await adminGetBlockedDates();

      const data = await response.json();

      setBlockedTimes(data.blockedDates);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddBlock = async () => {
    if (!selectedDate || !startTime || !endTime || !reason) {
      alert('Por favor, preencha todos os campos!');
      return;
    }

    const newBlock = {
      date: selectedDate,
      startTime,
      endTime,
      reason,
    };

    console.log('Enviando requisição para adicionar bloqueio com os seguintes dados:', newBlock);

    try {
      const response = await adminCreateBlockedDate(newBlock);
      
      if (!response.ok) throw new Error('Erro ao criar bloqueio');

      setSelectedDate('');
      setStartTime('');
      setEndTime('');
      setReason('');
      updateBlockedDates();

    } catch (error) {
      console.error(error);
    }
  };

  const handleRemoveBlock = async (id) => {
    try {
      const response = await adminDeleteBlockedDate(id);

      if (!response.ok) throw new Error('Erro ao remover bloqueio');

      updateBlockedDates();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <AdminContentContainer>
      <AdminContentTitle>Bloquear Datas/Horários</AdminContentTitle>
      <CancelDateForm>
        <CancelDateLabel>
          Data:
          <CancelDateInput type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
        </CancelDateLabel>
        <CancelDateLabel>
          Horário de início:
          <CancelDateInput type="time" value={startTime} onChange={(e) => setStartTime(e.target.value)} />
        </CancelDateLabel>
        <CancelDateLabel>
          Horário de término:
          <CancelDateInput type="time" value={endTime} onChange={(e) => setEndTime(e.target.value)} />
        </CancelDateLabel>
        <CancelDateLabel>
          Razão:
          <CancelDateInput type="text" value={reason} onChange={(e) => setReason(e.target.value)} />
        </CancelDateLabel>
        <SearchButton onClick={handleAddBlock}>Adicionar Bloqueio</SearchButton>
      </CancelDateForm>

      {loading ? <Spinner /> : (
        <BlockedList>
          {blockedTimes.length === 0 ? (
            <NoBlocks>Nenhum bloqueio adicionado.</NoBlocks>
          ) : (
            blockedTimes.map((block) => (
              <BlockedItem key={block.date}>
                <span>
                  <strong>Data:</strong> {block.date} | <strong>Horário:</strong> {block.startTime} - {block.endTime} | <strong>Razão:</strong> {block.reason}
                </span>
                <RemoveButton onClick={() => handleRemoveBlock(block.id)}>
                  Remover
                </RemoveButton>
              </BlockedItem>
            ))
          )}
        </BlockedList>
      )}
    </AdminContentContainer>
  );
};

export default BlockDates;
